import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { useEffect, useRef } from "react"

interface DeleteConfirmDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

// No busy state: delete is optimistic, so confirming closes the dialog immediately (PROD-452).
export default function DeleteConfirmDialog({ open, onClose, onConfirm }: DeleteConfirmDialogProps) {
  // One confirm per open cycle: the dialog stays clickable through its exit transition, and a second delete
  // would 404 and raise a spurious failure toast.
  const hasConfirmed = useRef(false)
  useEffect(() => {
    if (open) {
      hasConfirmed.current = false
    }
  }, [open])

  const handleConfirm = () => {
    if (hasConfirmed.current) {
      return
    }
    hasConfirmed.current = true
    onConfirm()
  }

  return <Dialog open={open} onClose={onClose}>
    <DialogTitle>Delete Confirmation</DialogTitle>
    <DialogContent>
      <DialogContentText>Are you sure you want to delete this thread and all its history? This action cannot be undone.</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={handleConfirm} color="warning">Delete</Button>
    </DialogActions>
  </Dialog>
}
